import { ioListOptions, ioSaveOption } from '@/febos/servicios/api/herramientas.api';

export async function saveNewEntities({ commit }, payload) {
  try {
    commit('SET_LOADING', true);
    const response = await ioSaveOption(payload.param, payload.body);
    return response;
  } finally {
    commit('SET_LOADING', false);
  }
}

export async function loadListEntities({ commit }, payload) {
  try {
    commit('SET_LOADING', true);
    const response = await ioListOptions(payload);
    commit('SET_LIST_ENTITIES', response.data);
  } finally {
    commit('SET_LOADING', false);
  }
}
